import type {RouteLocation, RouteRecordRaw} from 'vue-router';

export const EnterpriseGatewayApiRoute: RouteRecordRaw = {
    redirect: (to) => {
        window.location.href = import.meta.env.VITE_PUBLIC_API_URL;
        return '/';
    },
    path: '/api',
    name: 'EnterpriseGatewayApi',
    meta: { allowAnonymous: true }
};
